module.exports = __webpack_public_path__ + "static/media/georgia bold.d312a7a0.ttf";